import EntityType from '@enums/EntityType';
import getTagColors from '@pkg/utils/colors/tag';
import { TagColor } from '@/lib/enums';

export default function untaggedTag() {
  const color = TagColor.GREY_LIGHT;
  const taggables = [EntityType.ACTIVITY, EntityType.ROLE, EntityType.GROUP];

  return {
    category_uuid: null,
    color,
    description: `Work that hasn't been tagged`,
    is_disabled: false,
    is_system: true,
    name: 'Not tagged',
    order: 12,
    taggables,
    uuid: EntityType.UNTAGGED,
    __category: null,
    __color: getTagColors({ color }),
    __source: 'SYSTEM',
    __taggables_set: new Set(taggables),
  };
}
